"use client";

import type * as React from "react";
import { send } from "timvir/bus";
import { useArticleComponents, useContext } from "timvir/core";

export default function Sample({ language, children }: any) {
  const context = useContext();
  const components = useArticleComponents();

  return (
    <components.button
      role="button"
      onClick={(ev: React.SyntheticEvent) => {
        ev.preventDefault();
        send(context.bus, "code", "merge", {
          highlightedLines: undefined,
          language,
          children: code[language as any as keyof typeof code],
          caption: null,
        });
      }}
    >
      {children}
    </components.button>
  );
}

const code = {
  javascript: "function foo() {\n  const answer = 42;\n}",
  markdown: "# Lorem\n\nipsum dolor",
  html: `<!DOCTYPE html>
<html>
<body>

<h1>My First Heading</h1>

<p>My first paragraph.</p>

</body>
</html>
  `,
  haskell: `primes = filterPrime [2..]
where filterPrime (p:xs) =
        p : filterPrime [x | x <- xs, x \`mod\` p /= 0]`,
  css: `.gwbiq5k>:not(.nnbogi4) {
    grid-column: lc/rc;
    min-width: 0;
}`,
};
